import type FieldDraft from '@UI/Pages/Subjects/Shared/FormData/FieldDraft';

/** An empty draft clears the field; a boolean is never empty. */
const isFieldDraftEmpty = (draft: FieldDraft): boolean => {
	if (draft === null) {
		return true;
	}

	if (typeof draft === 'string') {
		return draft.trim() === '';
	}

	return Array.isArray(draft) && draft.length === 0;
};

export default isFieldDraftEmpty;
